import Container from 'containers/Tooltip/Container';
import React from 'react';

export default {
  Index() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return <Container cur={{type: 'WORD', id: 'id123', word: 'word', target: null as any}} />;
  },
};
